import { render, staticRenderFns } from "./DkOpenVideo.vue?vue&type=template&id=d2669a38&"
import script from "./DkOpenVideo.vue?vue&type=script&lang=js&"
export * from "./DkOpenVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports